import {
  GET_VALIDATE_ACTION_PLAN,
  GET_VALIDATE_ACTION_PLAN_SUCCESS,
  // PATCH_CONFIRM_ACTION_PLAN,
  PATCH_CONFIRM_ACTION_PLAN_SUCCESS,
  PATCH_VALIDATE_ACTION_PLAN,
  PATCH_VALIDATE_ACTION_PLAN_SUCCESS,
  VALID_OR_REJECT_TASKS_ACTION_PLAN,
  SET_ACTION_PLAN_ID_SUCCESS,
  // SPECIAL FOR ACTION PLAN THREAD
  GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID,
  GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID_SUCCESS,
  POST_MESSAGE_ACTION_PLAN_THREAD,
} from "./constants"

export function getValidateActionPlanAction(payload) {
  return {
    type: GET_VALIDATE_ACTION_PLAN,
    payload: payload,
  }
}

export function getValidateActionPlanSuccessAction(payload) {
  return {
    type: GET_VALIDATE_ACTION_PLAN_SUCCESS,
    payload: payload,
  }
}

export function patchValidateActionPlanAction(payload) {
  return {
    type: PATCH_VALIDATE_ACTION_PLAN,
    payload: payload,
  }
}

export function patchValidateActionPlanSuccessAction(payload) {
  return {
    type: PATCH_VALIDATE_ACTION_PLAN_SUCCESS,
    payload: payload,
  }
}

// export function patchConfirmActionPlanAction(payload) {
//   return {
//     type: PATCH_CONFIRM_ACTION_PLAN,
//     payload: payload,
//   }
// }

export function patchConfirmActionPlanSuccessAction(payload) {
  return {
    type: PATCH_CONFIRM_ACTION_PLAN_SUCCESS,
    payload: payload,
  }
}

export function setNewActionPlanIdSuccess(payload) {
  return {
    type: SET_ACTION_PLAN_ID_SUCCESS,
    payload: payload,
  }
}

export function validOrRejectTasksActionPlanAction(payload) {
  return {
    type: VALID_OR_REJECT_TASKS_ACTION_PLAN,
    payload: payload,
  }
}

// SPECIAL FOR ACTION PLAN THREAD
export function getActionPlanThreadAction(payload) {
  return {
    type: GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID,
    payload: payload,
  }
}

export function getActionPlanThreadSuccessAction(payload) {
  return {
    type: GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID_SUCCESS,
    payload: payload,
  }
}

export function postMessageActionPlanThreadAction(payload) {
  return {
    type: POST_MESSAGE_ACTION_PLAN_THREAD,
    payload: payload,
  }
}
